import userReducer from './user.slice';

export * from './user.slice';
export * from './user.thunk';

export default userReducer;
